import script from "./chair-motion-second-modal.vue?vue&type=script&lang=js"
export * from "./chair-motion-second-modal.vue?vue&type=script&lang=js"

import "./chair-motion-second-modal.vue?vue&type=style&index=0&id=1df8c60a&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df8c60a"]])

export default __exports__